'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowMore = function ShowMore(_ref) {
  var onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'ui-centered-wrapper' },
    _react2.default.createElement(
      'button',
      {
        className: 'rp-table-showmore ui-link ui-link_chevron',
        onClick: onClick
      },
      'Show more',
      _react2.default.createElement(_rpReactSvgIcon2.default, {
        iconName: 'down',
        size: 'Small',
        className: 'ui-icon ui-icon__btn'
      })
    )
  );
};

ShowMore.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

exports.default = ShowMore;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/components/ShowMore.js
// module id = 931
// module chunks = 0